import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isEmployeeExperience, isSystemAdmin } from '@/constants/capabilities';
import { getHomePath } from '@/constants/routes';
import { useAuthStore } from '@/stores/auth.store';

interface MobileEmployeeGuardProps {
  children: ReactNode;
}

export function MobileEmployeeGuard({ children }: MobileEmployeeGuardProps) {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  if (isSystemAdmin(user) || !isEmployeeExperience(user)) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  return <>{children}</>;
}
